import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsApp = () => {
  return (
    <div>
      <a href="https://wa.me/5492612529012?text=¡Hola%20necesitaria%20mas%20informacion%20sobre%20sus%20productos!" className="btn-wsp" target="blank">
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default WhatsApp;